<script context="module">
    let draggedItem;
    let draggedInfo;
</script>

<script>
    import {createEventDispatcher} from 'svelte';
    export let item = null;
    export let cssClass = '';
    export let parent = null;
    export let onMouseDown = event => {
    };
    export let columns = {};
    export let showCount = true;
    export let draggable = false;
    export let entity = '';
    export let onFocus = () => {};

    const dispatch = createEventDispatcher();

    let dropped = false;
    let insertAfter = true;
    let isClicked = false;

    let offsetLeft = 0;

    function handleMouseDown(event){
        isClicked = true;
        onMouseDown(event, item, parent);
    }

    function handleBlur(event){
        isClicked = false;
    }

    function onDragStart(event) {
        draggedItem = event.target;

        draggedInfo = {
            id: item.id,
            step: item.step,
            wsId: parent.id,
            roleId: parent.role_id,
            entity: 'element'
        }

        event.dataTransfer.setData('draggedInfo', JSON.stringify(draggedInfo));
    }

    function onDrag(event) {
        // empty but required to override the default behaviour
    }

    function onDragEnd(event) {
        //TODO: might need some indication/animation of the move to make it more obvious.
        draggedInfo = null;
    }

    function onDragOver(event) {
        if (draggable && draggedInfo) {
            if (draggedItem && !draggedItem.isEqualNode(event.target)) {
                event.dataTransfer.dropEffect = 'move';
                const height = event.target.offsetHeight;
                const middle = height / 2;
                if (event.offsetY < middle) {
                    insertAfter = false;
                    event.target.classList.add('before');
                    event.target.classList.remove('after');
                } else {
                    insertAfter = true;
                    event.target.classList.add('after');
                    event.target.classList.remove('before');
                }
            }
        }

    }

    function onDrop(event) {
        if (draggable) {
            const draggedInfoData = JSON.parse(event.dataTransfer.getData('draggedInfo'));
            if (draggedInfoData.wsId) {
                event.target.classList.remove('before');
                event.target.classList.remove('after');
                let destination = event.target;
                let offset = 0;

                if (draggedInfoData.entity === 'element') {
                    const destinationInfo = {
                        id: item.id,
                        step: item.step,
                        wsId: parent.id,
                        roleId: parent.role_id,
                        after: insertAfter,
                        entity: 'element'
                    };

                    //dispatch custom event after dropped
                    dispatch('itemMoved', {
                        from: draggedInfo,
                        to: destinationInfo
                    });
                }
            }
        }
    }

    function onDragLeave(event) {
        if (draggable) {
            event.target.classList.remove('before');
            event.target.classList.remove('after');
        }

    }

    function onShowMenu(event) {
        event.stopPropagation();
        const button = event.target;
        const menuPosition = {
            x: event.clientX,
            y: event.clientY
        };

        dispatch('showMenu', {
                    menuPosition, context: {
                        roleId: parent ? parent.role_id : item.role_id,
                        seqId: parent ? parent.id : item.id,
                        item,
                        entity
                    }
                },
        );
    }

    function onContextMenu(event) {
        onShowMenu(event);
        return false;
    }

    function handleFocus(event){
        onFocus(item, parent, entity, isClicked);
    }

</script>

<style>

    li.before {
        border-top: 3px solid #454545;
    }

    li.after {
        border-bottom: 3px solid #454545;
    }

    li * {
        pointer-events: none;
    }

    li.active.selected {
        background-color: #fab636;
    }

    li.active.copied.selected {
        background: rgba(250, 182, 54, 0.3);
    }
    li.copied.selected {
        background: rgba(250, 182, 54, 0.1);
    }

    li.copied, li.cut {
        border: 1px #454545 dashed;
    }

    li.cut {
        opacity: 0.5;
    }

    li div.btn {
        cursor: pointer;
        color: #dddddd;
        pointer-events: all;
    }

    li div.btn:hover {
        color: #454545;
    }

    li div.menu-toggle {
        color: #dddddd;
        pointer-events: none;
    }

    li div.menu-toggle.editable {
        cursor: pointer;
        color: #dddddd;
        pointer-events: all;
        text-align: center;
    }

    li div.menu-toggle.editable:hover {
        color: #454545;
    }

    .list-row > div {
        padding: 2px 3px;
    }
</style>

<li
        key={item.id}
        on:dragover|stopPropagation|preventDefault={onDragOver}
        on:drop|preventDefault|stopPropagation={onDrop}
        on:dragstart|stopPropagation={onDragStart}
        on:dragleave|stopPropagation={onDragLeave}
        on:drag|stopPropagation={onDrag}
        on:dragend|stopPropagation={onDragEnd}
        on:contextmenu|preventDefault={onContextMenu}
        on:focus={handleFocus}
        class="list-row {cssClass}"
        class:active={item.active}
        class:selected={item.selected}
        class:copied={item.copied}
        class:cut={item.cut}
        {draggable}
        on:mousedown={handleMouseDown}
        on:blur={handleBlur}
>
    {#if parent}
        <div></div>
    {/if}
    {#if showCount}
        <div>{item.step + 1}</div>
    {/if}
    {#each Object.keys(columns) as col, cIndex}
    <!-- Temporary handle toggle column, need to remove later -->
        {#if col !== 'toggle'}
            <div class={columns[col].class}>
                {#if columns[col].columnRenderer}
                    <svelte:component
                            this={columns[col].columnRenderer}
                            options={columns[col].options}
                            {col}
                            row={item}/>
                {:else}{item[col]}{/if}
            </div>
        {/if}

    {/each}
    <div
            class="menu-toggle"
            class:editable={draggable}
            on:mousedown={event => event.stopPropagation()}
            on:click|stopPropagation|preventDefault={onShowMenu}
    ><i class="fas fa-ellipsis-v"></i></div>
</li>
